import { getTeamAnalysisExportFile, getTeamAnalysisReportFile } from '@/api/calls/team-analysis/teamAnalysisExport.api';
import { downloadFile } from '@/helpers/generic';
import type { MeNotifications } from '@/types/api/me/me';
import type { TeamAnalysisExportData } from '@/types/notifications/notification';
import { useToast } from '@af-lib/vue-ui';

// Handles download of team analysis file both from notif and from toaster
export async function buildExportNotifAction(notification: MeNotifications<TeamAnalysisExportData>) {
  const toast = useToast();
  const filename = notification?.data?.filename;
  const fileType = notification?.data?.file_type;
  if (!filename) return;
  toast.dismiss(filename); // toaster created for this file has an id corresponding to the file name, this line removes the corresponding toaster
  // Same notification type for both formats — route to the right endpoint based on the file_type
  const isPdf = fileType === 'team_analysis_pdf_report';
  const res = isPdf ? await getTeamAnalysisReportFile(filename) : await getTeamAnalysisExportFile(filename);
  downloadFile(res.data, filename);
}
